import { configJson, prettyTeamUrl, prettyPlayerUrl } from 'rcs_gaz_mc_core_FE';

class ConfigManager {
  static getEnv() {
    configJson.urlToUse = process.env.REACT_APP_ENV;
    return process.env.REACT_APP_ENV;
  }

  static getContextRoot() {
    return configJson.endpoints[this.getEnv()];
  }

  static getServiceInfo(group, serviceName) {
    const serviceObject = configJson.serviceCollection[group][serviceName];
    return serviceObject;
  }

  static getApiVersion() {
    return configJson.apiVersion;
  }

  static getConstants() {
    return configJson.constants;
  }

  static buildUrl(contextRoot, apiName, urlParameters) {
    if (typeof urlParameters.version === 'undefined') {
      urlParameters.version = this.getApiVersion();
    }
    return `${contextRoot}${apiName(urlParameters)}`;
  }

  static getProbabiliEndpoint() {
    return configJson.endpoints.probabiliMethode;
  }

  static getSportRefreshInterval(sportId) {
    return configJson.sportRefreshInterval[sportId];
  }

  static getPlayerUrl(playerName, playerId, sportId, site) {
    return prettyPlayerUrl(playerName, playerId, sportId, site);
  }

  static getLanguageDictionary() {
    return configJson.dictionary[configJson.language];
  }
  static getRoute(routeName) {
    const routeObject = configJson.routes[routeName];
    return routeObject[this.getEnv()]();
  }
  static getColsOrder(tableName) {
    return configJson.tables.colsPosition[tableName];
  }
  static getJoinedCols(tableName) {
    return configJson.tables.joinedCols[tableName];
  }
  static getPositionMarker() {
    return configJson.tables.positionMarker;
  }
  static getSkipCols(tableName) {
    return configJson.tables.skipCols[tableName];
  }
  static getTabbarTabs() {
    return configJson.tables.tableTabbar.realteamPage;
  }
  static getFootballTeams(res) {
    return configJson.imageUrls.football.teams[res];
  }
  static getCountriesFlag() {
    return configJson.imageUrls.countriesFlag;
  }
  static getFootballPlayers() {
    return configJson.imageUrls.football.players;
  }
  static prettyTeamUrl(sportId, competitionId, site, team) {
    return prettyTeamUrl(sportId, competitionId, site, team);
  }
  static getMotorSportConstructor() {
    return configJson.imageUrls.teams;
  }
}

export default ConfigManager;



// WEBPACK FOOTER //
// ./src/lib/common/configManager/configManager.js